import React from "react";
import "./ChatRoomPicker.css";

/**
 * בחירת חדר בתוך הצ'אט בלבד — ללא PackagesProfile / layout האתר.
 * @param {object} props
 * @param {Array<Record<string, unknown>>} props.rooms
 * @param {boolean} props.disabled
 * @param {(roomIndex: number) => void} props.onPickRoom — אינדקס 0-based בתוך מערך rooms
 * @param {number|null|undefined} props.packagePriceIls — מחיר כרטיס החבילה (הקשר בלבד; לא SSOT לשורות מטריצה — כל שורה לפי roomSet)
 */
export default function ChatRoomPicker({ rooms, disabled, onPickRoom, packagePriceIls }) {
  const list = Array.isArray(rooms) ? rooms : [];

  if (list.length === 0) {
    return (
      <div className="hr-cvac-rpick hr-cvac-rpick--empty" dir="rtl">
        <p className="hr-cvac-rpick__intro">הנה אפשרויות החדרים הזמינות לחבילה שבחרתם:</p>
        <p className="hr-cvac-rpick__empty-msg">
          כרגע אין רשימת חדרים מפורטת במערכת. אפשר להמשיך בצ&apos;אט או לבקש מנציג.
        </p>
      </div>
    );
  }

  return (
    <div className="hr-cvac-rpick" dir="rtl">
      <p className="hr-cvac-rpick__intro">הנה אפשרויות החדרים הזמינות לחבילה שבחרתם:</p>
      <ul className="hr-cvac-rpick__list" role="list">
        {list.map((r, idx) => {
          const name =
            (typeof r?.room_name === "string" && r.room_name.trim()) ||
            (typeof r?.label_he === "string" && r.label_he.trim()) ||
            "חדר בחבילה";
          const board = typeof r?.board === "string" && r.board.trim() ? r.board.trim() : null;
          const occ =
            typeof r?.occupancy_label_he === "string" && r.occupancy_label_he.trim()
              ? r.occupancy_label_he.trim()
              : null;
          const cancel =
            typeof r?.refundable === "string" && r.refundable.trim() ? r.refundable.trim() : null;
          let priceLine = "טוען מחיר…";
          try {
            if (r?.price_ils != null && !Number.isNaN(Number(r.price_ils))) {
              priceLine = `₪${Math.round(Number(r.price_ils)).toLocaleString("he-IL")}`;
            }
          } catch {
            /* ignore */
          }
          const stableKey =
            (typeof r?.room_id === "string" && r.room_id.trim()) ||
            (typeof r?.stable_price_key === "string" && r.stable_price_key.trim()) ||
            (r?.seq_num != null && String(r.seq_num).trim()) ||
            null;
          const rowKey = stableKey || `${r?.kind || "r"}-${idx}-${r?.lds_deal_id || "na"}`;
          return (
            <li key={rowKey} className="hr-cvac-rpick__card">
              <div className="hr-cvac-rpick__card-body">
                <div className="hr-cvac-rpick__title">{name}</div>
                {occ ? <div className="hr-cvac-rpick__line">{occ}</div> : null}
                {board ? <div className="hr-cvac-rpick__line hr-cvac-rpick__line--muted">{board}</div> : null}
                {cancel ? (
                  <div className="hr-cvac-rpick__line hr-cvac-rpick__line--small">{cancel}</div>
                ) : null}
                <div className="hr-cvac-rpick__price-block">
                  <div className="hr-cvac-rpick__price">{priceLine}</div>
                  {typeof r?.price_subtitle_he === "string" && r.price_subtitle_he.trim() ? (
                    <div className="hr-cvac-rpick__price-note">{r.price_subtitle_he.trim()}</div>
                  ) : null}
                </div>
              </div>
              <button
                type="button"
                className="hr-cvac-rpick__btn"
                disabled={disabled}
                onClick={() => onPickRoom?.(idx)}
              >
                בחר חדר זה
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
